// src/components/MobileBottomBar.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    ShieldAlert,
    Truck,
    Snowflake,
    Tag,
    Thermometer,
} from "lucide-react";

const NAV_ITEMS = [
    {
        key: "panic",
        label: "Panic Mode",
        path: "/panic",
        icon: ShieldAlert,
        primary: true,
    },
    {
        key: "ricevimento",
        label: "Ricevimento Merci",
        path: "/ricevimento",
        icon: Truck,
    },
    {
        key: "abbattimenti",
        label: "Abbattimenti",
        path: "/abbattimenti",
        icon: Snowflake,
    },
    {
        key: "etichette",
        label: "Etichette",
        path: "/etichette",
        icon: Tag,
    },
    {
        key: "temperature",
        label: "Temperature",
        path: "/frighi",
        icon: Thermometer,
    },
];

function isItemActive(currentPath, itemPath) {
    if (itemPath === "/") return currentPath === "/";
    return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`);
}

export default function MobileBottomBar() {
    const navigate = useNavigate();
    const location = useLocation();

    const hiddenRoutes = [
        "/login",
        "/registrati",
        "/verifica-email",
        "/attiva",
        "/setup",
        "/termini",
        "/privacy",
        "/cookie-policy",
        "/security",
    ];

    const shouldHide = hiddenRoutes.some(
        (route) =>
            location.pathname === route || location.pathname.startsWith(`${route}/`)
    );

    if (shouldHide) return null;

    return (
        <>
            <nav
                className="
          md:hidden
          fixed
          bottom-[max(16px,env(safe-area-inset-bottom))]
          left-1/2
          -translate-x-1/2
          z-[999]
          w-[calc(100%-24px)]
          max-w-[343px]
        "
                aria-label="Navigazione rapida mobile"
            >
                <div
                    className="
            h-[60px]
            rounded-2xl
            bg-[#013768]
            shadow-[0px_20px_25px_-5px_rgba(0,0,0,0.10),0px_2px_4px_rgba(0,0,0,0.10)]
            overflow-hidden
            flex
            items-stretch
          "
                >
                    {NAV_ITEMS.map((item) => {
                        const Icon = item.icon;
                        const active = isItemActive(location.pathname, item.path);

                        if (item.primary) {
                            return (
                                <button
                                    key={item.key}
                                    type="button"
                                    onClick={() => navigate(item.path)}
                                    className="
                    w-[80px]
                    min-w-[80px]
                    h-full
                    rounded-2xl
                    bg-[#F43F5E]
                    text-white
                    flex
                    flex-col
                    items-center
                    justify-center
                    relative
                    transition-transform
                    active:scale-[0.98]
                  "
                                    aria-label={item.label}
                                    title={item.label}
                                >
                                    <Icon
                                        size={20}
                                        strokeWidth={2.2}
                                        className="text-white mb-[4px]"
                                    />
                                    <span className="text-[11px] leading-[11px] font-medium tracking-[0.01em]">
                                        Panic Mode
                                    </span>

                                    {active && (
                                        <span className="absolute inset-x-4 bottom-1 h-[2px] rounded-full bg-white/70" />
                                    )}
                                </button>
                            );
                        }

                        return (
                            <button
                                key={item.key}
                                type="button"
                                onClick={() => navigate(item.path)}
                                className="
                  flex-1
                  h-full
                  flex
                  items-center
                  justify-center
                  relative
                  text-white
                  transition
                  active:scale-[0.98]
                "
                                aria-label={item.label}
                                title={item.label}
                            >
                                <Icon
                                    size={24}
                                    strokeWidth={active ? 2.4 : 2}
                                    className={active ? "text-white opacity-100" : "text-white opacity-90"}
                                />

                                {active && (
                                    <span className="absolute bottom-[8px] w-[18px] h-[2px] rounded-full bg-white/75" />
                                )}
                            </button>
                        );
                    })}
                </div>
            </nav>

            {/* spazio sotto al contenuto solo su mobile */}
            <div className="md:hidden h-[92px]" />
        </>
    );
}
